import { FormatMinAndSec } from '../../../utilities/FormatDate'
import ellipsis from '../../../utilities/Ellipsis'
import { useEffect, useRef, useState } from 'react';

export const FlagsSection = ({ flags = [] }) => {
    const contentRef = useRef(null);
    const [barHeight, setBarHeight] = useState(0);

    useEffect(() => {
        if (contentRef.current) {
            setBarHeight(contentRef.current.scrollHeight); // Set the bar height dynamically
        }
    }, [flags]); // Recalculate when flags update


    return (
        <div className="d-flex flex-column patient-card-flags-details-width">
            <p className="m-0 text-purple flags-title">Flags</p>

            <div className="flags-list mt-2 d-flex">
                {/* The purple line with dynamic height */}

                {flags.length === 0 ? (
                    <p className="text-muted text-base">No flags recorded for this session.</p>
                ) : (
                    <>
                        <div className="ms-1 position-relative">
                            <div className="flags-bar" style={{ height: `${barHeight}px` }}></div>
                        </div>
                        {/* Flag content */}
                        <div ref={contentRef} className="ms-3 d-flex flex-column position-relative flags-content">
                            {flags.map((flag) => (
                                <div className="mb-3 position-relative flag-item" key={flag.timetick}>
                                    <div className="flags-dot"></div>
                                    <p className="text-base lh-sm font-bold mb-0">{FormatMinAndSec(flag.timetick)}</p>
                                    <p className="text-base lh-sm fw-normal mb-0 text-truncate">
                                        {ellipsis(flag.event_type, 12) || "No comment"}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </>)
                }
            </div>
        </div>
    )
}
